module.exports = __webpack_public_path__ + "img/gchrome.3ffe3585.svg";